/**
 * A form's field (see /styleguide): its label above its control (or
 * controls), and maybe a hint below
 */
import * as preact from "preact";

interface Props {
  label: string;
  /** The id of the control it labels, if just one */
  for?: string;
  hint?: preact.ComponentChildren;
  children: preact.ComponentChildren;
}

export default class Field extends preact.Component<Props> {
  render() {
    const { label, hint, children } = this.props;
    return (
      <div class="field">
        {this.props.for ? (
          <label class="fieldLabel" for={this.props.for}>
            {label}
          </label>
        ) : (
          <span class="fieldLabel">{label}</span>
        )}
        {children}
        {hint ? <span class="fieldHint">{hint}</span> : null}
      </div>
    );
  }
}
